<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-btn color="general" light class="mb-2" @click="newItem">{{
                    $t("language.new")
                  }}</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="grid.search"
                    append-icon="search"
                    :label="$t('language.search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-dialog v-model="dialog" max-width="600px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(save)">
                  <v-card>
                    <v-card-title>{{ $t("language.officehour") }}</v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.timein')"
                              rules="required|time"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.timein"
                                autocomplete="off"
                                :label="$t('language.timein')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.timeout')"
                              rules="required|time"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.timeout"
                                autocomplete="off"
                                :label="$t('language.timeout')"
                                :error-messages="errors[0]"
                                @change="calculateWorkingHour(vModel)"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.workinghour')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                disabled="disabled"
                                v-model="vModel.workinghour"
                                :label="$t('language.workinghour')"
                                :error-messages="errors[0]"
                                @change="calculateWorkingHour(vModel)"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm12 md4>
                            <ValidationProvider
                              :name="$t('language.effectivedate')"
                              :rules="effectivedaterule()"
                              v-slot="{ errors }"
                            >
                              <eng-nep-date-picker
                                :error-messages="errors[0]"
                                v-model="vModel.effectivedate"
                                :label="$t('language.effectivedate')"
                              ></eng-nep-date-picker>
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-subheader class="pad0">Weekend</v-subheader>
                            <v-divider class="mlr0"></v-divider>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.sun"
                              :label="$t('language.sun')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.mon"
                              :label="$t('language.mon')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.tue"
                              :label="$t('language.tue')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.wed"
                              :label="$t('language.wed')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.thu"
                              :label="$t('language.thu')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.fri"
                              :label="$t('language.fri')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-switch
                              v-model="vModel.weekend.sat"
                              :label="$t('language.sat')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-subheader class="pad0">
                              {{ $t("language.exceptionalofficehour") }}
                              <v-spacer />
                              <v-btn text small @click="addExceptionalHour">
                                <v-icon>add</v-icon>
                                {{ $t("language.add") }}
                              </v-btn>
                            </v-subheader>
                            <v-divider class="mlr0"></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-simple-table
                              v-if="vModel.exceptionalofficehours.length > 0"
                            >
                              <template v-slot:default>
                                <tbody>
                                  <tr
                                    v-for="item in vModel.exceptionalofficehours"
                                    :key="item.weekdayid"
                                  >
                                    <td>
                                      <ValidationProvider
                                        :name="$t('language.weekday')"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <v-autocomplete
                                          v-model="item.weekdayid"
                                          :items="weekDayList"
                                          item-text="text"
                                          item-value="value"
                                          :label="$t('language.weekday')"
                                          :error-messages="errors[0]"
                                          :clearable="true"
                                        ></v-autocomplete>
                                      </ValidationProvider>
                                    </td>
                                    <td>
                                      <ValidationProvider
                                        :name="$t('language.timein')"
                                        rules="required|time"
                                        v-slot="{ errors }"
                                      >
                                        <v-text-field
                                          v-model="item.timein"
                                          autocomplete="off"
                                          :label="$t('language.timein')"
                                          :error-messages="errors[0]"
                                          @change="calculateWorkingHour(item)"
                                        />
                                      </ValidationProvider>
                                    </td>
                                    <td>
                                      <ValidationProvider
                                        :name="$t('language.timeout')"
                                        rules="required|time"
                                        v-slot="{ errors }"
                                      >
                                        <v-text-field
                                          v-model="item.timeout"
                                          autocomplete="off"
                                          :label="$t('language.timeout')"
                                          :error-messages="errors[0]"
                                          @change="calculateWorkingHour(item)"
                                        />
                                      </ValidationProvider>
                                    </td>
                                    <td>
                                      <ValidationProvider
                                        :name="$t('language.workinghour')"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <v-text-field
                                          disabled="disabled"
                                          v-model="item.workinghour"
                                          :label="$t('language.workinghour')"
                                          :error-messages="errors[0]"
                                        />
                                      </ValidationProvider>
                                    </td>
                                    <td>
                                      <v-icon
                                        small
                                        @click="removeExceptionalHour(item)"
                                        >delete</v-icon
                                      >
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey darken-1" text @click="closedialog">{{
                        $t("language.cancel")
                      }}</v-btn>
                      <v-btn color="blue darken-1" text type="submit">{{
                        $t("language.save")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-data-table
              :headers="grid.headers"
              :items="grid.body"
              :search="grid.search"
              :options.sync="grid.options"
              :server-items-length="grid.total"
              :loading="grid.loading"
              :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
              class="elevation-2"
            >
              <template v-slot:header.timein>
                <span>{{ $t("language.timein") }}</span>
              </template>
              <template v-slot:header.timeout>
                <span>{{ $t("language.timeout") }}</span>
              </template>
              <template v-slot:header.workinghour>
                <span>{{ $t("language.workinghour") }}</span>
              </template>
              <template v-slot:header.effectivedate>
                <span>{{ $t("language.effectivedate") }}</span>
              </template>
              <template v-slot:header.action>
                <span>{{ $t("language.actions") }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.id)"
                  >edit</v-icon
                >
                <v-icon small @click="deleteItem(item.id)">delete</v-icon>
              </template>
            </v-data-table>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import Base from "../../../shared/Base.vue";
import commonservice from "../../../shared/common.service";
import TimePicker from "../../../components/shared/TimePicker";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
export default {
  name: "officehourview",
  extends: Base,
  components: {
    TimePicker,
    EngNepDatePicker,
  },
  data() {
    return {
      weekDayList: commonservice.weekDayList,
    };
  },
  created() {
    this.grid.headers = [
      { value: "timein" },
      { value: "timeout" },
      { value: "workinghour" },
      { value: "effectivedate" },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      timein: null,
      workinghour: null,
      effectivedate: moment()
        .add(1, "days")
        .format("YYYY-MM-DD"),
      weekend: {
        id: null,
        sun: false,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
      },
      exceptionalofficehours: [],
    };
    this.url = "client/setup/officehours";
  },
  methods: {
    addExceptionalHour() {
      this.vModel.exceptionalofficehours.push({
        timein: null,
        timeout: null,
        workinghour: null,
        weekdayid: null,
        active: true
      });
    },
    removeExceptionalHour(item) {
      var index = this.vModel.exceptionalofficehours.indexOf(item);
      if (index > -1) this.vModel.exceptionalofficehours.splice(index, 1);
    },
    calculateWorkingHour(item) {
      if (item == null)
        this.vModel.workinghour = commonservice.getTimeDifferenceInHour(
          this.vModel.timein,
          this.vModel.timeout
        );
      else
        item.workinghour = commonservice.getTimeDifferenceInHour(
          item.timein,
          item.timeout
        );
    },
    effectivedaterule() {
      var rule = "required";
      // if (this.$store.getters.role != "SUPERADMIN") {
      //   var minDate = moment()
      //     .add(1, "days")
      //     .format("YYYY-MM-DD");
      //   rule += `|mindate:'${minDate}'`;
      // }
      return rule;
    },
  },
};
</script>
